export const getR2File = (file?: string | null) => {
  const filePath = `https://pub-cf60b5990b0c4cf7835a1de74e9a4ae2.r2.dev`;

  if (file) {
    // If the file is already a full URL, we might want to return it as is
    // OR try to fix the domain if it matches the old one.
    if (file.startsWith("http")) {
      // Replace old domain if present
      return file.replace(
        "pub-0e7087cb11e043b8bc973f09a1919cbe.r2.dev",
        "pub-cf60b5990b0c4cf7835a1de74e9a4ae2.r2.dev"
      );
    }
    return `${filePath}/${file}`;
  }

  return null;
};
